var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-tabs',{attrs:{"variation":"site-navigation","alignment":"center","size":"large","content":_vm.tabsSiteNavContent},on:{"mds-tabs-item-active":function($event){$event.preventDefault();return _vm.setActiveNavItemOnClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }